import React from 'react';
import DynamicWidget from '@com/core/common/components/dynamicWidget';
import { TProductList, THit } from '@com/core/common/types/catalog';
import Loader from '@com/core/kul/components/Loader';
import HorizontalProductBoxCarousel from '../../common/ProductCarousel';
import ModuleHeader from '../moduleHeader/moduleHeader';

type TProps = {
    moduleData: TProductList;
    recommendedSkus: string[];
};

const DynamicProducts = ({ moduleData, recommendedSkus }: TProps): JSX.Element => {
    const { moduleHeader, textColor } = moduleData;

    return (
        <DynamicWidget productSkus={recommendedSkus}>
            {(data: THit | THit[] | null, isLoading: boolean): JSX.Element | null => {
                if (isLoading) {
                    return <Loader />;
                }
                if ((Array.isArray(data) && !data.length) || !data) {
                    return null;
                }
                return (
                    <div>
                        {moduleHeader && <ModuleHeader data={moduleHeader} textColor={textColor} />}
                        {Array.isArray(data) && (
                            <HorizontalProductBoxCarousel eventLocation="recos_page-static" products={data} />
                        )}
                    </div>
                );
            }}
        </DynamicWidget>
    );
};

export default React.memo(DynamicProducts);
